import { cn } from "@/lib/utils";

export function Container({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={cn("container-wrapper", className)}>
      <div className="container px-0">{children}</div>
    </section>
  );
}

export function SectionDivider({
  title,
  description,
}: {
  title: string;
  description?: string;
}) {
  return (
    <div className="flex items-end gap-3 pt-2">
      <div className="flex flex-col gap-0">
        <span className=" font-semibold text-foreground tracking-tight text-lg">
          {title}
        </span>
        {description && (
          <span className=" text-muted-foreground/50">{description}</span>
        )}
      </div>
      <div className="flex-1 h-px bg-border/30 mb-1" />
    </div>
  );
}
